"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        list: function (_a) {
            var offsetHeight = _a.offsetHeight, enableMinWidth = _a.enableMinWidth;
            return (__assign({ overflow: offsetHeight ? 'auto' : 'unset', height: "calc(100vh - ".concat(offsetHeight, ")") }, (enableMinWidth && { width: '100%', overflowX: 'auto', overflowY: 'hidden', whiteSpace: 'nowrap' })));
        },
    });
});
